import { createSelector } from 'reselect'

const selectDialogsDomain = (state: any) => state.dialogs
const selectDialogVisibility = createSelector(
  selectDialogsDomain,
  (dialogs) => dialogs.visibility
)
const selectDialogParams = (id: string) =>
  createSelector(selectDialogsDomain, (dialogs) => dialogs[id] || undefined)

export { selectDialogsDomain, selectDialogVisibility, selectDialogParams }
